import React from 'react';

export const VpWelcomeSvg = ({ ...rest }) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 1428 1428"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="714" cy="714" r="714" fill="url(#paint0_linear_2_102)" />
      <path
        d="M1041.15 775.576L1077.13 921.315L1067.36 921.315L1022.37 775.576L1041.15 775.576Z"
        fill="var(--primary-400)"
      />
      <path
        d="M860.843 778.033L831.594 924.922L821.829 924.922L840.765 778.033L860.843 778.033Z"
        fill="var(--primary-400)"
      />
      <rect
        x="647.12"
        y="924.336"
        width="596.76"
        height="402.164"
        fill="var(--primary-200)"
        stroke="var(--primary-300)"
        strokeWidth="9"
      />
      <rect x="868.603" y="981.563" width="170.534" height="11.5084" fill="var(--primary-100)" />
      <rect x="868.603" y="1114.43" width="170.534" height="11.5084" fill="var(--primary-100)" />
      <rect x="868.603" y="1247.3" width="170.534" height="11.5084" fill="var(--primary-100)" />
      <line
        x1="647.851"
        y1="1049.25"
        x2="1240.01"
        y2="1049.25"
        stroke="var(--primary-300)"
        strokeWidth="9"
      />
      <line
        x1="647.851"
        y1="1193.63"
        x2="1240.01"
        y2="1193.63"
        stroke="var(--primary-300)"
        strokeWidth="9"
      />
      <rect
        x="677.33"
        y="580"
        width="575.05"
        height="281.063"
        fill="url(#paint1_linear_2_102)"
        stroke="var(--primary-200)"
        strokeWidth="8"
      />
      <path
        d="M360.687 688.495H369.086V1163.72H360.687V688.495Z"
        fill="url(#paint2_linear_2_102)"
      />
      <path
        d="M276.35 1146.58H453.424L424.028 1331H309.595L276.35 1146.58Z"
        fill="url(#paint3_linear_2_102)"
      />
      <path
        d="M424.378 816.926C424.378 849.203 398.37 875.368 366.287 875.368C334.204 875.368 308.195 849.203 308.195 816.926C308.195 784.65 334.204 758.485 366.287 758.485C398.37 758.485 424.378 784.65 424.378 816.926Z"
        fill="url(#paint4_linear_2_102)"
      />
      <path
        d="M401.281 692.345C401.281 711.865 385.614 727.69 366.287 727.69C346.96 727.69 331.292 711.865 331.292 692.345C331.292 672.824 346.96 657 366.287 657C385.614 657 401.281 672.824 401.281 692.345Z"
        fill="url(#paint5_linear_2_102)"
      />
      <path
        d="M456.573 989.101C456.573 1039.16 416.151 1079.74 366.287 1079.74C316.423 1079.74 276 1039.16 276 989.101C276 939.044 316.423 898.464 366.287 898.464C416.151 898.464 456.573 939.044 456.573 989.101Z"
        fill="url(#paint6_linear_2_102)"
      />
      <rect x="1265.42" y="750.907" width="7.97508" height="451.257" fill="var(--primary-800)" />
      <path
        d="M1185.33 1185.88H1353.47L1325.56 1361H1216.9L1185.33 1185.88Z"
        fill="url(#paint7_linear_2_102)"
      />
      <path
        d="M1325.89 872.859C1325.89 903.507 1301.2 928.352 1270.73 928.352C1240.27 928.352 1215.57 903.507 1215.57 872.859C1215.57 842.211 1240.27 817.366 1270.73 817.366C1301.2 817.366 1325.89 842.211 1325.89 872.859Z"
        fill="url(#paint8_linear_2_102)"
      />
      <path
        d="M1303.96 754.562C1303.96 773.097 1289.08 788.124 1270.73 788.124C1252.38 788.124 1237.5 773.097 1237.5 754.562C1237.5 736.026 1252.38 721 1270.73 721C1289.08 721 1303.96 736.026 1303.96 754.562Z"
        fill="url(#paint9_linear_2_102)"
      />
      <path
        d="M1356.46 1036.35C1356.46 1083.88 1318.08 1122.41 1270.73 1122.41C1223.38 1122.41 1185 1083.88 1185 1036.35C1185 988.816 1223.38 950.283 1270.73 950.283C1318.08 950.283 1356.46 988.816 1356.46 1036.35Z"
        fill="url(#paint10_linear_2_102)"
      />
      <rect x="234" y="443" width="12" height="679" fill="var(--primary-800)" />
      <path
        d="M113.5 1097.5H366.5L324.5 1361H161L113.5 1097.5Z"
        fill="url(#paint11_linear_2_102)"
      />
      <path
        d="M325 626.5C325 672.616 287.84 710 242 710C196.16 710 159 672.616 159 626.5C159 580.384 196.16 543 242 543C287.84 543 325 580.384 325 626.5Z"
        fill="url(#paint12_linear_2_102)"
      />
      <path
        d="M292 448.5C292 476.39 269.614 499 242 499C214.386 499 192 476.39 192 448.5C192 420.61 214.386 398 242 398C269.614 398 292 420.61 292 448.5Z"
        fill="url(#paint13_linear_2_102)"
      />
      <path
        d="M371 872.5C371 944.021 313.245 1002 242 1002C170.755 1002 113 944.021 113 872.5C113 800.979 170.755 743 242 743C313.245 743 371 800.979 371 872.5Z"
        fill="url(#paint14_linear_2_102)"
      />
      <path d="M596.17 1268H664.17V1338H596.17V1268Z" fill="var(--primary-600)" />
      <path d="M824.17 1268H892.17L909.67 1338H841.67L824.17 1268Z" fill="var(--primary-600)" />
      <path
        d="M836.17 717H680.67L821.67 1273H905.17L836.17 717Z"
        fill="url(#paint15_linear_2_102)"
      />
      <path d="M590.17 717H727.17L678.017 1274H590.17V717Z" fill="url(#paint16_linear_2_102)" />
      <path
        d="M654.233 381.035L720.542 376.005L763.744 720.724L670.013 727.835L654.233 381.035Z"
        fill="var(--primary-100)"
      />
      <path
        d="M652.67 379.5C674.17 379.5 641.307 476.039 605.67 491C570.032 505.961 529.964 794.675 529.964 794.675L459.886 783C459.886 783 523.269 379.5 652.67 379.5Z"
        fill="var(--primary-700)"
      />
      <path
        d="M784.705 477.51C784.705 477.51 750.205 445.51 759.205 392.01C827.205 379.01 876.205 343.51 876.205 343.51L863.579 211.642L936.343 200.01C936.343 200.01 969.205 348.01 945.705 386.51C922.204 425.009 784.705 477.51 784.705 477.51Z"
        fill="var(--primary-700)"
      />
      <path
        d="M778.326 399.739C746.962 368.986 714.248 371.468 714.248 371.468C714.248 371.468 736.608 698.086 764.222 743.18C791.836 788.274 856.347 764.845 856.347 764.845C856.347 764.845 809.691 430.492 778.326 399.739Z"
        fill="url(#paint17_linear_2_102)"
      />
      <path
        d="M598.555 413.841C625.972 378.666 659.875 376.094 659.875 376.094C659.875 376.094 687.105 701.968 665.733 750.725C644.36 799.481 574.657 786.216 574.657 786.216C574.657 786.216 571.137 449.016 598.555 413.841Z"
        fill="url(#paint18_linear_2_102)"
      />
      <rect x="662.17" y="326" width="54" height="94" rx="27" fill="var(--primary-700)" />
      <path
        d="M731.568 267.962C739.455 303.963 731.995 356.56 691.251 365.485C656.291 373.144 618.775 330.4 610.888 294.4C603.001 258.399 603.163 221.138 657.518 211.502C706.505 202.818 723.681 231.962 731.568 267.962Z"
        fill="var(--primary-600)"
      />
      <path
        d="M654.117 294.144C655.004 298.19 651.157 294.626 647.17 295.5C643.182 296.374 640.564 301.354 639.677 297.307C638.791 293.261 641.305 289.273 645.292 288.4C649.28 287.526 653.231 290.098 654.117 294.144Z"
        fill="var(--primary-700)"
      />
      <path
        d="M706.102 282.756C706.988 286.802 703.142 283.238 699.154 284.112C695.167 284.985 692.548 289.965 691.662 285.919C690.776 281.873 693.289 277.885 697.277 277.011C701.264 276.138 705.216 278.71 706.102 282.756Z"
        fill="var(--primary-700)"
      />
      <path
        d="M708.867 262.669C709.75 266.699 697.709 263.679 693.62 264.575C689.53 265.471 681.808 272.82 680.925 268.79C680.043 264.76 688.231 259.542 692.321 258.646C696.411 257.75 707.985 258.639 708.867 262.669Z"
        fill="var(--primary-800)"
      />
      <path
        d="M656.709 274.095C657.592 278.125 645.551 275.106 641.461 276.002C637.371 276.898 629.65 284.247 628.767 280.217C627.884 276.186 636.072 270.969 640.162 270.073C644.252 269.177 655.826 270.065 656.709 274.095Z"
        fill="var(--primary-800)"
      />
      <path
        d="M730.135 207.878C727.413 237.158 696.651 241.949 669.868 247.816C635.611 248.371 590.301 247.728 606.922 209.541C620.347 178.696 655.401 197.039 675.99 196.706C696.579 196.373 729.784 186.182 730.135 207.878Z"
        fill="var(--primary-800)"
      />
      <path
        d="M620.554 304.563C610.095 303.879 603.009 277.185 601.286 264.117C599.564 251.049 592.97 226.154 610.888 227.859C622.288 232.75 616.569 246.065 619.127 265.468C620.849 278.535 621.54 286.949 620.554 304.563Z"
        fill="var(--primary-800)"
      />
      <path
        d="M729.12 278.79C738.597 273.677 733.878 246.452 729.937 233.874C725.997 221.296 713.808 194.851 704.452 200.057C695.883 209.384 708 224.086 713.851 242.761C717.792 255.338 720.719 263.257 729.12 278.79Z"
        fill="var(--primary-800)"
      />
      <path
        d="M632.199 292.833C636.908 302.168 641.759 315.538 628.008 322.474C616.523 328.268 605.717 318.028 601.008 308.694C596.299 299.36 598.384 288.464 607.718 283.755C617.053 279.046 627.491 283.499 632.199 292.833Z"
        fill="var(--primary-600)"
      />
      <path
        d="M746.995 278.059C745.851 288.451 742.625 302.303 727.316 300.617C714.53 299.21 711.057 284.734 712.2 274.342C713.344 263.95 721.035 255.954 731.427 257.098C741.818 258.242 748.139 267.667 746.995 278.059Z"
        fill="var(--primary-600)"
      />
      <path
        d="M688.17 1368H577.17C577.17 1368 577.17 1308 632.67 1308C688.17 1308 688.17 1368 688.17 1368Z"
        fill="var(--primary-800)"
      />
      <path
        d="M960.169 1368H828.17C828.17 1368 811.17 1327 904.669 1316.5C974.311 1308.68 960.169 1368 960.169 1368Z"
        fill="var(--primary-800)"
      />
      <path
        d="M873.17 188L912.67 179L919.17 203.259L878.67 209.759L873.17 188Z"
        fill="var(--primary-600)"
      />
      <path
        d="M474.67 785L517.67 792.5L510.67 816L471.17 809.5L474.67 785Z"
        fill="var(--primary-600)"
      />
      <path
        d="M508.996 845.5C512.996 895.5 515.707 903.5 494.996 903.5C474.285 903.5 457.17 880.033 457.17 848C457.17 815.967 476.959 790 497.67 790C518.38 790 511.996 822 508.996 845.5Z"
        fill="var(--primary-600)"
      />
      <path
        d="M909.27 126.744C922.195 155.06 919.94 182.048 900.137 191.087C880.334 200.126 859.752 185.105 846.827 156.788C833.902 128.472 834.036 111.23 853.331 88.5441C890.486 96.1641 896.345 98.4277 909.27 126.744Z"
        fill="var(--primary-600)"
      />
      <circle
        cx="1150.5"
        cy="236.5"
        r="132.5"
        fill="var(--primary-200)"
        stroke="#F0F6FF"
        strokeWidth="12"
      />
      <path d="M1143.54 149.459H1151.66V246.945H1143.54V149.459Z" fill="var(--primary-100)" />
      <path d="M1143.54 251.587V243.463H1210.85V251.587H1143.54Z" fill="var(--primary-100)" />
      <defs>
        <linearGradient
          id="paint0_linear_2_102"
          x1="714"
          y1="0"
          x2="714"
          y2="1033.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-100)" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_102"
          x1="964.855"
          y1="584"
          x2="1303"
          y2="1322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-400)" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_102"
          x1="366.287"
          y1="657"
          x2="366.287"
          y2="1331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-500)" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2_102"
          x1="366.287"
          y1="657"
          x2="366.287"
          y2="1331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-500)" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2_102"
          x1="366.287"
          y1="657"
          x2="366.287"
          y2="1331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-500)" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2_102"
          x1="366.287"
          y1="657"
          x2="366.287"
          y2="1331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-500)" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2_102"
          x1="366.287"
          y1="657"
          x2="366.287"
          y2="1331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-100)" />
          <stop offset="1" stopColor="var(--primary-500)" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2_102"
          x1="1269.4"
          y1="1185.88"
          x2="1276.38"
          y2="1488.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-700)" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2_102"
          x1="1270.73"
          y1="721"
          x2="1270.73"
          y2="1360"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2_102"
          x1="1270.73"
          y1="721"
          x2="1270.73"
          y2="1360"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2_102"
          x1="1270.73"
          y1="721"
          x2="1270.73"
          y2="1360"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2_102"
          x1="240"
          y1="1097.5"
          x2="250.5"
          y2="1552.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-700)" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2_102"
          x1="242"
          y1="398"
          x2="242"
          y2="1359.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2_102"
          x1="242"
          y1="398"
          x2="242"
          y2="1359.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2_102"
          x1="242"
          y1="398"
          x2="242"
          y2="1359.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-400)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2_102"
          x1="681.17"
          y1="717"
          x2="861.17"
          y2="1005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-800)" />
          <stop offset="1" stopColor="var(--primary-700)" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_2_102"
          x1="658.67"
          y1="717"
          x2="658.67"
          y2="1274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-600)" />
          <stop offset="1" stopColor="var(--primary-800)" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_2_102"
          x1="628.583"
          y1="485.776"
          x2="606.428"
          y2="841.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-600)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_2_102"
          x1="628.583"
          y1="485.776"
          x2="606.428"
          y2="841.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-600)" />
          <stop offset="1" stopColor="var(--primary-900)" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default VpWelcomeSvg;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpWelcomeSvg/VpWelcomeSvg.jsx